<span class="status-indicator__wrapper status-indicator__wrapper--{{ status() }}">
  <span class="status-indicator__dot"></span>
  <span class="status-indicator__label">{{ status() === 'UP' ? 'Online' : 'Offline' }}</span>
</span>
